export default __webpack_public_path__ + "static/media/create_website.ee19d3f4.svg";